// Format large numbers to be more readable in the chart
export const formatLargeNumber = (
  num?: number,
  prefix: string = '$',
): string => {
  if (num && num >= 1e9) {
    return prefix + (num / 1e9).toFixed(1) + 'B';
  }
  if (num && num >= 1e6) {
    return prefix + (num / 1e6).toFixed(1) + 'M';
  }
  if (num && num >= 1e3) {
    return prefix + (num / 1e3).toFixed(1) + 'K';
  }
  return prefix + num?.toString();
};
